import { injectable } from 'inversify'
import { QuizSessionReducerPlugin } from '@/app/quiz-session/api'
import { StartExamSessionCommand, UpdateExamSessionQuestionStateCommand,
         UpdateExamSessionNavigationCommand, UpdateExamSessionQuestionTimesCommand } from './exam-session-commands'
import { ExamSessionState } from './exam-session-state'
import { reduceQuizSessionQuestionStates, reduceQuizSessionNavigation,
         reduceQuizSessionQuestionTimes, initialQuizSessionQuestionStates,
         initialQuizSessionQuestionTimes } from '@/app/quiz-session/api'

@injectable()
export class ExamSessionReducerPlugin implements QuizSessionReducerPlugin<ExamSessionState, ExamSessionCommand>  {

  reduce(state: ExamSessionState, command: ExamSessionCommand): ExamSessionState {

    switch (command.name) {
      case 'start-exam-session': {
        const payload = command.payload
        return {
          startTime: payload.startTime,
          questionIds: payload.questionIds,
          navigation: {
            questionIndex: payload.questionIndex,
            lastIndex: payload.questionIndex
          },
          questionStates: initialQuizSessionQuestionStates(payload.questionIds.length),
          questionTimes: initialQuizSessionQuestionTimes(payload.questionIds.length)
        }
      }
      case 'update-exam-session-question-state': {
        const payload = command.payload
        return {
          ...state,
          questionStates: reduceQuizSessionQuestionStates(state.questionStates, payload)
        }
      }
      case 'update-exam-session-navigation': {
        const payload = command.payload
        return {
          ...state,
          navigation: reduceQuizSessionNavigation(state.navigation, payload)
        }
      }
      case 'update-exam-session-question-times': {
        const payload = command.payload
        return {
          ...state,
          questionTimes: reduceQuizSessionQuestionTimes(state.questionTimes, payload)
        }
      }
    }
  }
}

type ExamSessionCommand = StartExamSessionCommand | UpdateExamSessionQuestionStateCommand |
      UpdateExamSessionNavigationCommand | UpdateExamSessionQuestionTimesCommand
